import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { ContentContainer } from '../../../../common/ui/content-container';

type HeaderSideBySideProps = {
	components: {
		filters: JSX.Element;
	};
};

const baseHeaderStyles = xcss({
	backgroundColor: 'elevation.surface',
	width: '100%',
});

const headerGridStyles = xcss({
	paddingTop: 'space.400',
	paddingBottom: 'space.200',
});

const HeaderSideBySide = ({ components }: HeaderSideBySideProps) => {
	const { filters } = components;

	return (
		<>
			<Box
				xcss={[baseHeaderStyles]}
				testId="search-page-header"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={{ zIndex: 10 }} // The smallest z-index from xcss options is too big (100)
			>
				<ContentContainer>
					<Box xcss={headerGridStyles}>{filters}</Box>
				</ContentContainer>
			</Box>
		</>
	);
};

export default HeaderSideBySide;
